import { render, staticRenderFns } from "./CreateOrganizationModal.vue?vue&type=template&id=77596cb3&scoped=true"
import script from "./CreateOrganizationModal.vue?vue&type=script&lang=ts"
export * from "./CreateOrganizationModal.vue?vue&type=script&lang=ts"
import style0 from "./CreateOrganizationModal.vue?vue&type=style&index=0&id=77596cb3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77596cb3",
  null
  
)

export default component.exports